// 匿名图片只保存在当前页面，不读写其他客户的搜索历史。
export const createImageSearchContext=(identity:()=>string)=>{
  let generation=0,disposed=false
  return {
    capture:()=>({identity:identity(),generation}),
    current:(snapshot:{identity:string;generation:number})=>!disposed && snapshot.generation===generation && snapshot.identity===identity(),
    reset:()=>{generation++},
    dispose:()=>{disposed=true;generation++}
  }
}

export const createImageSearchSession=()=>{
  let nextId=-1
  const files=new Map<number,File>()
  const matches=new Map<number,any[]>()
  const objectUrls=new Map<number,string>()
  const remove=(id:number)=>{
    id=Number(id)
    const url=objectUrls.get(id)
    if(url)URL.revokeObjectURL(url)
    objectUrls.delete(id)
    files.delete(id)
    matches.delete(id)
  }
  return {
    remember(data:any,file:File,host:string,authenticated:boolean){
      const id=authenticated && Number(data?.id)>0?Number(data.id):nextId--
      if(id<0)files.set(id,file)
      const url=String(data?.imgUrl || data?.imageUrl || '')
      const originalUrl=url?(/^https?:\/\//.test(url)?url:host.replace(/\/$/,'')+'/'+url):URL.createObjectURL(file)
      if(!url)objectUrls.set(id,originalUrl)
      return {id,originalUrl,fileType:0}
    },
    rememberRemote(data:any,host:string){
      const id=nextId--
      matches.set(id,Array.isArray(data?.actions)?data.actions:[])
      const url=String(data?.imageUrl || data?.imgUrl || '')
      return {id,originalUrl:/^https?:\/\//.test(url)?url:host.replace(/\/$/,'')+'/'+url,fileType:0}
    },
    file:(id:number)=>files.get(Number(id)),
    matches:(id:number)=>matches.get(Number(id)),
    remove,
    clear(){new Set([...Array.from(files.keys()),...Array.from(matches.keys()),...Array.from(objectUrls.keys())]).forEach(remove)}
  }
}
